<script lang="ts" setup>
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import CustomerForm from '@/components/features/customers/CustomerForm.vue'
import OrderHistory from '@/components/features/customers/OrderHistory.vue'
import LinkedProducts from '@/components/features/customers/LinkedProducts.vue'

import {useRouter} from 'vue-router'
import {useCustomerForm} from '@/composables/useCustomerForm'
import {onMounted, ref} from "vue";
import {getCustomerOrders} from "@/api/orders";

const router = useRouter()
const { values, addressFields, newAddress, removeAddress, setErrors, formType } =
  useCustomerForm('view')

const orderHistory = ref<any[]>([])
const isLoading = ref(false)

const fetchOrderHistory = async () => {
  try {
    isLoading.value = true
    const customerId = router.currentRoute.value.params.id as string
    orderHistory.value = await getCustomerOrders(customerId)
  } catch (error) {
    console.error('Failed to fetch order history:', error)
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  fetchOrderHistory()
})

const editCustomer = () => {
  router.push(`/customers/${router.currentRoute.value.params.id}/edit`)
}
</script>

<template>
  <PageHeader
    :title="values?.businessName"
    buttonText="Edit Customer"
    buttonIcon="basil:edit-solid"
    :buttonClick="editCustomer"
  />
  <TabView class="bg-white rounded-md">
    <TabPanel header="Customer Details">
      <CustomerForm
        :type="formType"
        :values="values"
        :onSubmit="editCustomer"
        :addressFields="addressFields"
        :newAddress="newAddress"
        :removeAddress="removeAddress"
        :setErrors="setErrors"
      />
    </TabPanel>
    <TabPanel header="Order History">
      <OrderHistory :orderHistory="orderHistory" :loading="isLoading" />
    </TabPanel>

    <TabPanel header="Linked Products">
      <LinkedProducts />
    </TabPanel>
  </TabView>
</template>
<style></style>
